module.exports = __webpack_public_path__ + "static/media/Group_alert.76f54f48.svg";